export const styles = (theme) => ({});
export const editStyles = (theme) => ({
  root: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(3),
    // width : '100%',
  },
});
